import { updateRemote } from '../atomic';
import ENTITIES from '..';
import { execAfterUserConfirmation } from '../../app/actions';

export function changeTimeslotAvailability(store, data) {
  execAfterUserConfirmation(store, () => {
    updateRemote(store, ENTITIES.TIMESLOTS, data);
  });
}
